import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import React, { useContext } from 'react'
import AccordionContext from 'react-bootstrap/AccordionContext'
import styled from 'styled-components/macro'
import { DropdownSVG } from '../../Icons/Basic'

type Props = {
  onToggled: (newState: boolean) => void
  defaultKey?: string
}

export function ExpandButton(props: Props): JSX.Element {
  const onClick = useAccordionButton(props.defaultKey ?? '0')
  const { activeEventKey } = useContext(AccordionContext)
  const isExpanded = Boolean(activeEventKey)
  return (
    <ExpandIconButton
      onClick={onClick}
      onToggled={props.onToggled}
      isExpanded={isExpanded}
    />
  )
}

type ExpandIconButtonProps = Omit<Props, 'defaultKey'> & {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  isExpanded: boolean
}
export function ExpandIconButton({
  onClick,
  onToggled,
  isExpanded,
}: ExpandIconButtonProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={(e) => {
        onClick?.(e)
        onToggled(!isExpanded)
      }}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
      }}
      aria-expanded={isExpanded}
    >
      <DropdownIcon $isToggled={isExpanded} />
    </button>
  )
}

export const DropdownIcon = styled(DropdownSVG)<{ $isToggled: boolean }>`
  transform: ${(props) => {
    return props.$isToggled ? 'scaleY(-1)' : 'scaleY(1)'
  }};
  transition: transform 0.25s;
`
